import React from "react";
import { Alert, Row, Col } from "reactstrap";
import { Icon } from "@cadmakers-ui/icons";
import { Link } from "react-router-dom";
import styles from "../Styles/ErrorDisplay.module.scss";
import { appPaths, ForbiddenDisplay } from "..";
import iconStyles from "../Styles/Icons.module.scss";

type Props = {
  errorCode?: number;
  errorResult?: string; // like "Could not load feedbacks"
  errorDescription?: string; // like "An exception occurred on the server"
};

/* eslint class-methods-use-this: ["error", { "exceptMethods": ["getSubmitBugReportUrl"] }] */
export default class ErrorDisplay extends React.Component<Props> {
  getSubmitBugReportUrl(): string {
    const encodedUrlOfThisPage = encodeURIComponent(window.location.href);

    return `${appPaths.feedback.submitFeedback}?type=bug&app=CMF&link=${encodedUrlOfThisPage}&errorCode=${this.props.errorCode}`;
  }

  render() {
    if (this.props.errorCode === 403 && !!this.props.errorDescription) {
      return <ForbiddenDisplay description={this.props.errorDescription} />;
    }

    return (
      <Alert className="alert-danger">
        <Row>
          <Col colSpan={8}>
            <p>
              <b>{this.props.errorResult}</b>
            </p>
            <p>{this.props.errorDescription}</p>
            <small>
              {!!this.props.errorCode && (
                <span className={styles.statusCodeDisplay}>
                  Status Code: {this.props.errorCode}
                </span>
              )}
              <Link to={this.getSubmitBugReportUrl()}>Click here to submit a Bug Report</Link>
            </small>
          </Col>
          <Col colSpan={4} className={styles.errorIconCol}>
            <Icon
              appName="GeneralLayout"
              assetName="GENERAL_L_Error"
              className={iconStyles.smallIcon}
            />
          </Col>
        </Row>
      </Alert>
    );
  }
}
